export class NewsList {
  items: HTMLAnchorElement[];

  constructor() {
    this.items = Array.from(
      document.querySelectorAll("#news-list li > a")
    ) as HTMLAnchorElement[];

    this.init();
  }

  init() {
    this.items.forEach((item, index) => {
      item.addEventListener("pointerover", () => {
        this.updateActiveItem(index);
      });

      // add move for more stability when scrolling
      item.addEventListener("pointermove", () => {
        this.updateActiveItem(index);
      });

      item.addEventListener("focus", () => {
        this.updateActiveItem(index);
      });

      item.addEventListener("pointerleave", () => {
        this.updateActiveItem(-1);
      });

      item.addEventListener("blur", () => {
        this.updateActiveItem(-1);
      });
    });
  }

  updateActiveItem = (index: number) => {
    this.items.forEach((item, itemIndex) => {
      const itemFade =
        index >= 0
          ? this.getItemFade(itemIndex, index)
          : { opacity: 1, blur: 0 };

      item.style.setProperty("--fade-opacity", itemFade.opacity.toString());
      item.style.setProperty("--fade-blur", `${itemFade.blur}px`);
    });
  };

  getItemFade = (index: number, activeIndex: number) => {
    if (index === activeIndex) {
      return { opacity: 1, blur: 0 };
    }

    if (Math.abs(index - activeIndex) === 1) {
      return { opacity: 0.4, blur: 1 };
    }

    if (Math.abs(index - activeIndex) === 2) {
      return { opacity: 0.24, blur: 1.5 };
    }

    return { opacity: 0.12, blur: 2 };
  };
}
